import * as yup from "yup";
import {startOfDay} from "date-fns";

const getValidationSchema = (guestStays) => {
    return yup.object().shape({
        checkOutDate: yup
            .string()
            .typeError('Campo non valido')
            .required('Campo obbligatorio'),
        guestStayIds: yup
            .array()
            .min(1, 'Devi selezionare almeno un ospite per procedere con il check out')
            .test(
                'al-least-one-night',
                'La data di partenza degli ospiti deve essere maggiore della data di arrivo',
                (value, testContext) => {
                    const {checkOutDate} = testContext.parent;
                    const departureDate = startOfDay(new Date(checkOutDate))
                    return guestStays.filter(s => value.includes(s.id)).every(s => departureDate > startOfDay(s.arrival));
                }
            )
            .typeError('Campo non valido')
            .required('Campo obbligatorio')
    })
}

export default getValidationSchema;